import createWebStorage from 'redux-persist/lib/storage/createWebStorage';

const createNoopStorage = () => ({
  getItem: () => Promise.resolve(null),
  setItem: (_, value) => Promise.resolve(value),
  removeItem: () => Promise.resolve(),
});

const storage =
  // eslint-disable-next-line no-negated-condition -- FIXME
  typeof window !== 'undefined'
    ? createWebStorage('local')
    : createNoopStorage();

export default storage;
